/* KOBOONI: scroll-snapped, manually operated banner navigation */
(function () {
  if (window.__kbStudioCarouselInitialized) return;
  window.__kbStudioCarouselInitialized = true;
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-km-move]');
    if (!button) return;
    var slider = button.closest('[data-km-carousel]');
    if (!slider) return;
    var track = slider.querySelector('[data-km-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.km-slide');
    if (!slides.length) return;
    var next = Number(button.getAttribute('data-km-move')) || 0;
    var current = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    var idx = (current + next + slides.length) % slides.length;
    track.scrollTo({left: idx * track.clientWidth, behavior: 'smooth'});
    var label = slider.querySelector('[data-km-page]');
    if (label) label.textContent = (idx + 1) + ' / ' + slides.length;
  });
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || !track.matches || !track.matches('[data-km-track]')) return;
    var root = track.closest('[data-km-carousel]');
    var label = root && root.querySelector('[data-km-page]');
    if (!label) return;
    var count = track.querySelectorAll('.km-slide').length;
    label.textContent = (Math.min(count - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))) + 1) + ' / ' + count;
  }, true);

  // Shoppable hotspots: accessible native modal, cart AJAX, no full-page redirect.
  var kmLastHotspot = null;
  document.addEventListener('click', function (event) {
    var target = event.target;
    var open = target.closest('[data-km-hotspot-open]');
    if (open) {
      var dialog = document.getElementById(open.getAttribute('data-km-hotspot-open'));
      if (dialog && !dialog.open) {
        kmLastHotspot = open;
        dialog.showModal();
      }
      return;
    }
    var close = target.closest('[data-km-hotspot-close]');
    if (close) {
      var parentDialog = close.closest('dialog');
      if (parentDialog) parentDialog.close();
      return;
    }
    if (target.matches('dialog.km-hotspot-dialog')) target.close();
  });
  document.addEventListener('close', function (event) {
    if (event.target.matches && event.target.matches('dialog.km-hotspot-dialog')) {
      if (kmLastHotspot && document.contains(kmLastHotspot)) kmLastHotspot.focus({preventScroll:true});
      kmLastHotspot = null;
    }
  }, true);
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-km-variant-select]');
    if (!select) return;
    var option = select.selectedOptions[0];
    var price = select.closest('dialog').querySelector('[data-km-price]');
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });
  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-km-cart-add]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var message = form.closest('dialog').querySelector('[data-km-cart-message]');
    if (!button || button.disabled) return;
    button.disabled = true;
    var original = button.textContent;
    button.textContent = 'Adding…';
    if (message) message.textContent = '';
    try {
      var payload = new FormData(form);
      var url = form.action + '.js';
      var response = await fetch(url, {method:'POST',body:payload,headers:{'Accept':'application/json'}});
      var item = await response.json();
      if (!response.ok) throw new Error(item.description || item.message || 'Unable to add to cart');
      if (message) message.textContent = 'Added to cart. Continue browsing or select View cart.';
      button.textContent = 'Added ✓';
      document.dispatchEvent(new CustomEvent('cart:updated', {detail:{source:'kobooni-hero'}}));
    } catch (error) {
      if (message) message.textContent = error && error.message ? error.message : 'Add to cart failed. Please try again.';
      button.textContent = original;
    } finally {
      button.disabled = false;
    }
  });

})();
